export default __webpack_public_path__ + "images/home-automation-install-service.jpg";